import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import "./App.css";
import JSConfetti from "js-confetti";
import Theme from "./misc/theme/theme";
import LandingPage from "./pages/landing-page/landing-page";
import CollectionPage from "./pages/collection-page/collection-page";
import ProductPage from "./pages/product-page/product-page";
import CheckoutPage from "./pages/checkout-page/checkout-page";
import CartPage from "./pages/cart-page/cart-page";
import CheckoutComplete from "./pages/checkout-complete/checkout-complete";
import AdminPage from "./pages/admin/admin-page";
import UserService from "./services/session/user-service";
import { AccountType } from "./models/data/user-session";
import RegisterPage from "./pages/authentication/register-page";
import LoginPage from "./pages/authentication/login-page";
import AdminProductPage from "./components/admin-pages/admin-product-page";
import AdminCollectionPage from "./components/admin-pages/admin-collection-page";
import OurAdvantagesPage from "./pages/misc/our-advantages";
import AccountPage from "./pages/account/account-page";
import PrivacyPolicyPage from "./pages/misc/privacy-policy";
import TermsAndConditionsPage from "./pages/misc/terms-and-conditions";
import FaqPage from "./pages/misc/faqs";
import ThankYouPage from "./pages/thank-you-page/thank-you-page";
import AdminOrderPage from "./components/admin-pages/admin-order-page";
import ProductsPage from "./pages/products-page/products-page";

declare global {
	interface Window {
		confetti: any;
	}
}

function App() {
	window.confetti = new JSConfetti();

	const [isLoggedIn, setIsLoggedIn] = useState<boolean>(UserService.getCurrentSession() !== null);
	const [isAdmin, setIsAdmin] = useState<boolean>(UserService.getCurrentSession()?.accountType === AccountType.Admin);

	useEffect(() => {
		var sub = UserService.sessionChangeEvent.subscribe(() => {
			console.log('current session changed')
			setIsLoggedIn(UserService.getCurrentSession() !== null)
			setIsAdmin(UserService.getCurrentSession()?.accountType === AccountType.Admin);
		});

		return () => {
			UserService.sessionChangeEvent.unsubscribe(sub);
		};
	}, [])

	useEffect(() => {
		setIsLoggedIn(UserService.getCurrentSession() !== null)
		setIsAdmin(UserService.getCurrentSession()?.accountType === AccountType.Admin);
	}, [])

	useEffect(() => {
		console.log('session change', isLoggedIn, isAdmin);
		if (!isAdmin && window.location.pathname.indexOf('/admin') > -1) window.location.href = `${window.location.origin}`;
		if (!isLoggedIn && window.location.pathname.indexOf('/account') > -1) window.location.href = `${window.location.origin}`;
		if (isLoggedIn && window.location.pathname.indexOf('/login') > -1) window.location.href = `${window.location.origin}`;
		if (isLoggedIn && window.location.pathname.indexOf('/register') > -1) window.location.href = `${window.location.origin}`;
	}, [isAdmin, isLoggedIn]);

	return (
		<>
			<Router>
				<Routes>
					<Route path="*" element={<Navigate replace to="/" />} />

					<Route path="/" element={<Theme />}>
						<Route index element={<LandingPage />}></Route>

						<Route path="collections" element={<CollectionPage />}></Route>
						<Route path="collections/:handle" element={<CollectionPage />}></Route>

						<Route path="products" element={<ProductsPage />}></Route>

						<Route path="product/:handle" element={<ProductPage />}></Route>
						<Route path="product/:handle/:variantSKU" element={<ProductPage />}></Route>

						<Route path="cart" element={<CartPage />}></Route>
						<Route path="checkout">
							<Route index element={<CheckoutPage status={'new'} />}></Route>
							{/* Pulls the order, navigates to the correct page */}
							<Route path="complete" element={<CheckoutComplete />}></Route>
							<Route path="declined" element={<CheckoutPage status={'declined'} />}></Route>
							<Route path="thank-you/:orderId" element={<ThankYouPage />}></Route>
						</Route>

						{/* MISC */}
						<Route path="pages">
							<Route path="our-advantages" element={<OurAdvantagesPage />} />
							<Route path="privacy-policy" element={<PrivacyPolicyPage />} />
							<Route path="terms-and-conditions" element={<TermsAndConditionsPage />} />
							<Route path="faqs" element={<FaqPage />} />
						</Route>

						{!isLoggedIn && <>
							<Route path="login" element={<LoginPage />}></Route>
							<Route path="register" element={<RegisterPage />}></Route>
						</>
						}

						{isLoggedIn && <>
							<Route path="account">
								<Route index element={<AccountPage />}></Route>
							</Route>
						</>
						}

						{isLoggedIn && isAdmin && <>
							<Route path="admin">
								<Route index element={<AdminPage />}></Route>
								<Route path="products/edit/:handle" element={<AdminProductPage pageType={'edit'} />}></Route>
								<Route path="products/create" element={<AdminProductPage pageType={'new'} />}></Route>

								<Route path="collections/edit/:handle" element={<AdminCollectionPage pageType={'edit'} />}></Route>
								<Route path="collections/create" element={<AdminCollectionPage pageType={'new'} />}></Route>

								<Route path="orders/view/:id" element={<AdminOrderPage />}></Route>
							</Route>
						</>
						}
					</Route>
				</Routes>
			</Router>
		</>
	);
}

export default App;
